<script setup lang="ts">
import { Text } from '~ds/components/ui/typography';

import { CLICKFUNNEL_CONTACT_URL } from '~/constants/constants';

/**
 * The pre-join disclosure required by the AU interim rollout (CP-11269), shared by every
 * surface that can accept a school invite so the copy can't drift between them.
 */
interface Props {
  /** Off when the surface already renders its own privacy link (the terms card does). */
  showPrivacyLink?: boolean;
  /** Off for someone who has just created their account, who has no existing profile to share. */
  showSharedProfile?: boolean;
}

withDefaults(defineProps<Props>(), { showPrivacyLink: true, showSharedProfile: true });

const { t } = useI18n();
// Coins and prizes are an AU consumer offer, so the no-rewards notice only means something there.
const { isAus } = useClusterCountryConfig();
</script>

<template>
  <div class="flex flex-col gap-3 text-left" data-testid="school-join-explanation">
    <Text v-if="showSharedProfile" size="sm">
      {{ t('unified.join.explanation.sharedProfile') }}
    </Text>
    <Text v-if="isAus" size="sm">
      {{ t('unified.join.explanation.noRewards') }}
    </Text>
    <Text size="sm">
      {{ t('unified.join.explanation.verifyInvite') }}
    </Text>
    <div class="flex gap-6">
      <KUICoreLink
        v-if="showPrivacyLink"
        :text="t('unified.join.explanation.privacyLink')"
        :to="clusterUrl('/privacy-policy')"
        is-external
        class="underline"
      />
      <KUICoreLink
        :text="t('unified.join.explanation.supportLink')"
        :to="CLICKFUNNEL_CONTACT_URL"
        is-external
        class="underline"
      />
    </div>
  </div>
</template>
